export default {
  showLoginBox: false, //是否显示登录窗口
  userInfo: {},
  isLogin: false,
  provinceName: "",
  introduceInfo: {
    BuildLogic: null,
    BuildTarget: null,
    Id: "",
    Introduce: "",
    LogoUrl: "",
    ProjectGroupName: ""
  } //专业群信息
};